import { extractPackageFile } from './extract';

export { extractPackageFile };

export const defaultConfig = {
  fileMatch: ['^\\.gitlab-ci\\.yml$'],
};
